export const contactsData = {
    email: 'salupixel@gmail.com',
    phone: '+92 3480 583568',
    address: 'Sector G-9/1, Islamabad, Pakistan - 673822',

    sheetAPI: ''
}